<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" :title="$t('title.skuSearch')" centered destroyOnClose width="70%">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"></vxe-button>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.item.name.length > 10" :key="row.sku.id" :title="row.item.name">
          <a-tag :key="row.sku.id" :closable="true" color="blue" @close="() => closeTag(row)">{{`${row.item.name.slice(0, 10)}...`}}</a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.sku.id" :closable="true" color="blue" @close="() => closeTag(row)">{{row.item.name}}</a-tag>
      </template>
      <a-divider/>
    </template>
    <a-space>
      <a-input-search v-model="query['item.name']" :placeholder="$t('business.label.itemName')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('business.label.lot')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['manufacturer']" :placeholder="$t('business.label.manufacturer')" @pressEnter="search" @search="search"/>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="storer.no" title="business.label.storerNo" width="80"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'SkuModal',
  data() {
    return {
      size: 15,
      page: 1,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: { 'item.no': '', 'item.name': '', 'lot.no': '', 'manufacturer': '' },
      args: null,
      selectedRows: [],
      record: undefined,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.5)// 表格竖向滚动条
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    }
  },
  methods: {
    init(args) {
      this.query = { 'item.no': '', 'item.name': '', 'lot.no': '', 'manufacturer': '' }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('skuFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>